import { ICookieOptions, setCookie } from '@cian/utils/lib/browser/cookie';

export function setChatOnboardingCookie(cookieName: string) {
  const cookieConfig: ICookieOptions = { expires: 365 * 86400, secure: false };

  setCookie(cookieName, '1', cookieConfig);
}
